import React from "react";
import FamilyForm from "../components/FamilyForm/FamilyForm";

function EditFamily() {
  return <FamilyForm isEdit />;
}

export default EditFamily;
